/* unplugin-vue-components disabled */import { render } from "./LCAside.vue?vue&type=template&id=174c184c&scoped=true"
import script from "./LCAside.vue?vue&type=script&lang=js"
export * from "./LCAside.vue?vue&type=script&lang=js"

import "./LCAside.vue?vue&type=style&index=0&id=174c184c&scoped=true&lang=css"

import exportComponent from "E:\\电梯项目文档\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174c184c"]])

export default __exports__